// Bootstraps funnel tracking on every desktop page of a brand.
//
// This used to sit in the vue_helper.js pack, which existed only as Vue
// plumbing but was loaded by every desktop layout -- the tracking just
// rode along with it. With Vue gone that pack is gone too, so each
// templates/* pack imports this instead; those are likewise loaded on
// every page of a brand (see ApplicationHelper#webpack_component_files),
// so coverage is unchanged.
//
// The window.* exposure is for the legacy CoffeeScript bundles (Sprockets,
// no ES module support), which call these defensively behind typeof
// checks -- see app/assets/javascripts/mobile/step_1.js.coffee.
import {
  initFunnelTracking,
  logFunnelEvent,
  getLandingRenderedAt
} from "app/helpers/classes/funnel_tracking";

initFunnelTracking();

window.logFunnelEvent = logFunnelEvent;
window.getLandingRenderedAt = getLandingRenderedAt;
